import { ref, watchEffect } from 'vue';
import { cachedDeliveryteamOrders } from "@deliveryteam-spa-orders-vue/refs/RecentOrders";
import { DELIVERYTEAM_ORDER_STATUS_OBJ } from "@lib/types/deliveryteamOrderStatus";
// import { callNative } from "@deliveryteam-spa-orders-vue/native";

export const isAbleToPlayAudio = ref(true);
// Sound interval reference to clear when needed
let soundInterval: ReturnType<typeof setInterval> | null = null;
// Title flashing interval
let titleInterval: ReturnType<typeof setInterval> | null = null;
// notification interval reference to clear when needed
// let notificationInterval: ReturnType<typeof setInterval> | null = null;

// Deliveryteam original document title
let originalTitle = document.title;

export function setMediaSessionMetadata() {
    if ('mediaSession' in navigator) {
        navigator.mediaSession.metadata = new MediaMetadata({
            title: 'Courier Orders',
            artist: document.title,
            // @ts-ignore
            // artwork_old: [],
            artwork: [
                {
                    "src": "https://dummyimage.com/320x180/000/fff.jpeg&text=Z",
                    "sizes": "320x180",
                    "type": "image/jpeg"
                },
                {
                    "src": "https://dummyimage.com/60x60/000/fff.jpeg&text=Z",
                    "sizes": "60x60",
                    "type": "image/jpeg"
                },
                {
                    "src": "https://dummyimage.com/120x120/000/fff.jpeg&text=Z",
                    "sizes": "120x120",
                    "type": "image/jpeg"
                },
                {
                    "src": "https://dummyimage.com/226x226/000/fff.jpeg&text=Z",
                    "sizes": "226x226",
                    "type": "image/jpeg"
                },
                {
                    "src": "https://dummyimage.com/544x544/000/fff.jpeg&text=Z",
                    "sizes": "544x544",
                    "type": "image/jpeg"
                },
                {
                    "src": "https://dummyimage.com/96x96/000/fff.jpeg&text=Z",
                    "sizes": "96x96",
                    "type": "image/jpeg"
                },
                {
                    "src": "https://dummyimage.com/128x128/000/fff.jpeg&text=Z",
                    "sizes": "128x128",
                    "type": "image/jpeg"
                },
                {
                    "src": "https://dummyimage.com/192x192/000/fff.jpeg&text=Z",
                    "sizes": "192x192",
                    "type": "image/jpeg"
                },
                {
                    "src": "https://dummyimage.com/256x256/000/fff.jpeg&text=Z",
                    "sizes": "256x256",
                    "type": "image/jpeg"
                },
                {
                    "src": "https://dummyimage.com/384x384/000/fff.jpeg&text=Z",
                    "sizes": "384x384",
                    "type": "image/jpeg"
                },
                {
                    "src": "https://dummyimage.com/512x512/000/fff.jpeg&text=Z",
                    "sizes": "512x512",
                    "type": "image/jpeg"
                },
            ],
        });
    }
}

setMediaSessionMetadata();

setInterval(() => {
    setMediaSessionMetadata();
}, 120_000);

export const playBlankAudioLoop = () => {
    const audio = document.getElementById('blank-loop') as HTMLAudioElement;
    if (audio) {
        audio.loop = true;
        audio.play()
            .then(() => {
                isAbleToPlayAudio.value = true;
            })
            .catch(() => {
                isAbleToPlayAudio.value = false;
                // console.warn('📣📣📣Audio permission denied📣📣📣');
                // console.error(error);
            });
    }
    // Play new order audio with volume 0 and then increase to 1 after 2 seconds
    // maybe this can warm up the tab to play audio later
    const newOrderAudio = document.getElementById('notification-audio') as HTMLAudioElement;
    newOrderAudio.volume = 0;
    // newOrderAudio.play();
    // playNotificationAudio();
    // make volume 1 after finished playing newOrderAudio
    const handleNewOrderAudioEnded = () => {
        setTimeout(() => {
            newOrderAudio.volume = 1;
        }, 1000);
        newOrderAudio.removeEventListener('ended', handleNewOrderAudioEnded);
    }
    newOrderAudio.addEventListener('ended', handleNewOrderAudioEnded);
    startPauseListener();
}

let isListenerStarted = false;
const startPauseListener = () => {
    if (isListenerStarted) return;
    isListenerStarted = true;
    const audio = document.getElementById('blank-loop') as HTMLAudioElement;
    audio.addEventListener('pause', () => {
        audio.play().catch(() => { console.error('Failed to play paused audio'); });
    });
}


export const playNotificationAudio = () => {
    const audio = document.getElementById('notification-audio') as HTMLAudioElement;
    if (audio) {
        audio.currentTime = 0;
        // if (import.meta.env.DEV) {
        //     audio.volume = 0.1;
        // }
        audio.play()
            .then(() => {
                console.log('📣📣📣Audio played📣📣📣');
                isAbleToPlayAudio.value = true;
            })
            .catch(() => {
                isAbleToPlayAudio.value = false;
                // console.warn('📣📣📣Audio permission denied📣📣📣');
                // console.error(error);
            });
    }
    return audio;
}

const flashTitle = (newOrdersCount: number) => {
    if (!titleInterval) {
        originalTitle = document.title;
    }

    if (titleInterval) {
        clearInterval(titleInterval);
    }

    let isAlert = false;
    titleInterval = setInterval(() => {
        if (isAlert) {
            document.title = originalTitle;
        } else {
            document.title = `🚨 ${newOrdersCount} new ${newOrdersCount === 1 ? 'order' : 'orders'}`;
        }
        setMediaSessionMetadata();
        isAlert = !isAlert;
    }, 2000);
}

// Watch for orders with "PLACED" status and play notification sounds
export const watchNewOrders = () => {
    watchEffect(() => {
        const newOrders = Object.values(cachedDeliveryteamOrders.value).filter(
            order => order.orderStatus === DELIVERYTEAM_ORDER_STATUS_OBJ.PLACED
        );

        const hasNewOrders = newOrders.length > 0;

        // Clear existing interval if any
        if (soundInterval) {
            clearInterval(soundInterval);
            soundInterval = null;
        }

        // if (notificationInterval) {
        //     clearInterval(notificationInterval);
        //     notificationInterval = null;
        // }

        // Stop title flashing if no new orders
        if (!hasNewOrders && titleInterval) {
            clearInterval(titleInterval);
            titleInterval = null;
            document.title = originalTitle;
            setMediaSessionMetadata();
        }
        if (hasNewOrders) {
            // Flash title with count of new orders
            flashTitle(newOrders.length);
        }

        // Set up interval only if there are new orders
        if (hasNewOrders) {
            // Play immediately when detected
            playNotificationAudio();

            // Then set up interval to play every 5 seconds
            soundInterval = setInterval(() => {
                playNotificationAudio();
            }, 5_000);

            // notificationInterval = setInterval(async () => {
            //     await callNative('dismissAllNotifications', undefined);
            //     await callNative('cancelAllScheduledNotifications', undefined);
            //     await callNative('showNotification', {
            //         title: `🚨 ${newOrders.length} new ${newOrders.length === 1 ? 'order' : 'orders'}`,
            //         body: `You have ${newOrders.length} new ${newOrders.length === 1 ? 'order' : 'orders'}`,
            //         urgent: true,
            //     });
            // }, 30_000);
        }
    });
}
